<template>
  <section>
    <h5>{{ texto }}</h5>
    <p v-if="ayuda">{{ ayuda }}</p>
    <hr>
    <validation-provider name="País" :rules="{ required: req }" v-slot="validationContext">
      <b-form-group label-cols-md="4" label="País:" :label-for="'select-pais-' + realId">
        <b-form-select :id="'select-pais-' + realId" v-model="respuesta.pais" :state="getValidationState(validationContext)" @change="onPaisChange">
          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
          <b-form-select-option v-for="entry in paises" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
        </b-form-select>
        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider name="Departamento/Estado" :rules="{ required: req }" v-slot="validationContext">
      <b-form-group label-cols-md="4" label="Departamento/Estado:" :label-for="'select-estado-' + realId">
        <b-form-select :id="'select-estado-' + realId" v-model="respuesta.estado" :state="getValidationState(validationContext)" @change="onDepartamentoChange" v-if="estados.length > 0">
          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
          <b-form-select-option v-for="entry in estados" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
        </b-form-select>
        <b-form-input :id="'select-estado-' + realId" v-model="respuesta.estado" :state="getValidationState(validationContext)" maxlength="128" v-else></b-form-input>
        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider name="Municipio" :rules="{ required: req }" v-slot="validationContext">
      <b-form-group label-cols-md="4" label="Municipio:" :label-for="'select-ciudad-' + realId">
        <b-form-select :id="'select-ciudad-' + realId" v-model="respuesta.ciudad" :state="getValidationState(validationContext)" @change="onCiudadChange" v-if="ciudades.length > 0">
          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
          <b-form-select-option v-for="entry in ciudades" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
        </b-form-select>
        <b-form-input :id="'select-ciudad-' + realId" v-model="respuesta.ciudad" :state="getValidationState(validationContext)" maxlength="128" v-else></b-form-input>
        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider name="Barrio" :rules="{ required: req }" v-slot="validationContext">
      <b-form-group label-cols-md="4" label="Barrio:" :label-for="'input-barrio-' + realId">
        <b-form-select :id="'select-barrio-' + realId" v-model="respuesta.barrio" :state="getValidationState(validationContext)" v-if="barrios.length > 0">
          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
          <b-form-select-option v-for="entry in barrios" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
        </b-form-select>
        <b-form-input :id="'input-ciudad-' + realId" v-model="respuesta.barrio" :state="getValidationState(validationContext)" maxlength="128" v-else></b-form-input>
        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider name="Dirección" :rules="{ required: req }" v-slot="validationContext">
      <b-form-group label-cols-md="4" label="Dirección:" :label-for="'input-direccion-' + realId">
        <street-address v-model="respuesta.direccion" :state="getValidationState(validationContext)"></street-address>
        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>

    <validation-provider name="Localizar en el mapa" :rules="{ required: req }" v-slot="validationContext">
      <b-form-group>
        <p class="font-italic">Por favor confirma que tu ubicación geográfica en el mapa corresponde a tu ubicación real, si consideras que no es correcto puedes ubicar el punto manualmente, esta información es muy importante para nosotros</p>

        <div class="float-left d-inline">
          <b-button variant="link" @click.prevent="geoLocalizar" title="Haz clic aqui para intentar localizar la dirección, o búscala manualmente en el mapa">Clic aquí para ubicar la dirección ingresada en el mapa</b-button>
        </div>
        <div class="float-right d-inline">
          <b-button variant="primary" @click.prevent="$refs.map.geoLocalizar()">
            <b-icon icon="map"></b-icon>Ubica tu posición actual en el mapa
          </b-button>
        </div>
        <g-map ref="map" :center="map.center" :zoom="map.zoom" @change="onMapChange" style="width: 100%; height:320px"></g-map>
        <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        <input type="hidden" v-model="respuesta.gps.lat" />
        <input type="hidden" v-model="respuesta.gps.lng" />
      </b-form-group>
    </validation-provider>
  </section>
</template>

<script lang="ts">
import loadGoogleMapsApi from 'load-google-maps-api'
import axios from 'axios'
import { nanoid } from 'nanoid'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { url } from '../../services/url_service'
import settings from '../../settings'

@Component
export default class TipoTexto extends Vue {
  @Prop() id: string
  @Prop() texto: string
  @Prop({ default: '' }) ayuda: string
  @Prop({ default: true }) requerida: Boolean
  @Prop() placeholder: string
  @Prop() value: any

  get realId(): string {
    return this.id || 'direccion-' + nanoid()
  }

  get req() {
    if (!this.requerida) {
      if (
        this.respuesta.pais == null &&
        this.respuesta.estado == null &&
        this.respuesta.ciudad == null &&
        this.respuesta.barrio == null &&
        this.respuesta.direccion == null &&
        this.respuesta.gps.lat == null &&
        this.respuesta.gps.lng == null
      ) {
        return false
      }
    }
    return true
  }

  public respuesta: any = {
    pais: null,
    estado: null,
    ciudad: null,
    barrio: null,
    direccion: null,
    gps: {
      lat: null,
      lng: null,
    },
  }
  public paises: Array<any> = []
  public estados: Array<any> = []
  public ciudades: Array<any> = []
  public barrios: Array<any> = []

  public map: any = {
    /** Inicialmente las coordenadas de Cartagena */
    center: {
      lat: 10.39972,
      lng: -75.51444,
    },
    zoom: 10,
  }

  getValidationState({ validated, dirty = null, valid = null, passed = null }) {
    return validated || valid ? valid : null
  }

  @Watch('respuesta', {
    deep: true,
  })
  onRespuestaChange(value) {
    this.$emit('input', value)
  }

  @Watch('value')
  onValueChange(value, oldValue) {
    this.respuesta = value
    if (oldValue !== value) {
      this.init()
    }
  }

  async geoLocalizar() {
    let client = await loadGoogleMapsApi({
      //key: 'AIzaSyCPOQy9j0sxxC1cLmc1YXSLLlcBvmZp_ZU',
      key: settings.gmapKey,
    })
    let geocoder = new client.Geocoder()
    //let client = new Client({})
    try {
      if (this.respuesta?.pais && this.respuesta?.direccion) {
        let direccion = `${this.respuesta?.direccion?.replaceAll('/', ' ')},`
        direccion = direccion.substring(0, direccion.indexOf('|'))
        direccion += this.respuesta?.barrio
          ? `${this._filtroLugar(this.barrios, this.respuesta?.barrio)},`
          : ''
        direccion += this.respuesta?.ciudad
          ? `${this._filtroLugar(this.ciudades, this.respuesta?.ciudad)},`
          : ''
        direccion += this.respuesta?.estado
          ? `${this._filtroLugar(this.estados, this.respuesta?.estado)},`
          : ''
        direccion += this.respuesta?.pais
          ? `${this._filtroLugar(this.paises, this.respuesta?.pais)}`
          : ''
        let self = this
        geocoder.geocode(
          {
            address: direccion,
          },
          function (res) {
            let location = res[0]?.geometry?.location
            self.respuesta.gps = location
            let map: google.maps.Map = self.$refs.map['getMap']()
            map?.setCenter(location)
            map?.setZoom(16)
          }
        )
      }
    } catch (error) {
      //console.log(error)
    }
  }

  async onMapChange(map) {
    this.respuesta.gps = map.getCenter()
  }

  async onPaisChange() {
    this.respuesta.estado = null
    this.respuesta.ciudad = null
    this.estados = []
    this.ciudades = []
    this.barrios = []
    this.estados = (
      await axios.get(url.create('/public/lugares/estados'), {
        params: {
          pais: this.respuesta.pais,
        },
      })
    )?.data
  }

  async onDepartamentoChange() {
    this.respuesta.ciudad = null
    this.ciudades = []
    this.barrios = []
    this.ciudades = (
      await axios.get(url.create('/public/lugares/ciudades'), {
        params: {
          estado: this.respuesta.estado,
        },
      })
    )?.data
  }

  async onCiudadChange() {
    this.respuesta.barrio = null
    this.barrios = []
    this.barrios = (
      await axios.get(url.create('/public/lugares/barrios'), {
        params: {
          ciudad: this.respuesta.ciudad,
        },
      })
    )?.data
  }

  async init() {
    this.paises = (await axios.get(url.create('/public/lugares/paises')))?.data
    if (this.respuesta.pais) {
      this.estados = (
        await axios.get(url.create('/public/lugares/estados'), {
          params: {
            pais: this.respuesta.pais,
          },
        })
      )?.data
    }
    if (this.respuesta.estado) {
      this.ciudades = (
        await axios.get(url.create('/public/lugares/ciudades'), {
          params: {
            estado: this.respuesta.estado,
          },
        })
      )?.data
    }
    if (this.respuesta.ciudad) {
      this.barrios = (
        await axios.get(url.create('/public/lugares/barrios'), {
          params: {
            ciudad: this.respuesta.ciudad,
          },
        })
      )?.data
    }
  }

  created() {
    this.respuesta = this.value || {
      pais: null,
      estado: null,
      ciudad: null,
      barrio: null,
      direccion: null,
      gps: {
        lat: null,
        lng: null,
      },
    }
    this.init()
  }

  _filtroLugar(donde: Array<object>, que: string): string {
    if (donde.length > 0) {
      return donde.filter(function (item) {
        return item['key'] === que
      })[0]['value']
    } else {
      return que
    }
  }
}
</script>